<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考试成绩核实</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">查看学员</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl">
          <div class="searchbox">
            <div title="姓名" class="searchboxItem ci-full">
              <span class="itemLabel">姓名:</span>
              <el-input v-model="searchForm.userName" clearable size="small" placeholder="请输入姓名"></el-input>
            </div>
            <div title="手机号" class="searchboxItem ci-full">
              <span class="itemLabel">手机号:</span>
              <el-input v-model="searchForm.mobile" clearable size="small" placeholder="请输入手机号"></el-input>
            </div>
            <div title="阅卷状态" class="searchboxItem ci-full">
              <span class="itemLabel">阅卷状态:</span>
              <el-select v-model="searchForm.scoringState" placeholder="请选择阅卷状态" size="small" clearable>
                <el-option v-for="item in scoringStateList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="df">
              <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
            </div>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              style="width: 100%" :header-cell-style="tableHeader">
              <el-table-column label="序号" align="center" type="index" fixed :index="indexMethod" width="100px" />
              <el-table-column label="姓名" align="center" show-overflow-tooltip prop="userName" />
              <el-table-column label="性别" align="center" show-overflow-tooltip prop="sex">
                <template slot-scope="scope">
                  {{ $setDictionary("SEX", scope.row.sex) }}
                </template>
              </el-table-column>
              <el-table-column label="手机号" align="center" show-overflow-tooltip prop="mobile" />
              <el-table-column label="状态" align="center" show-overflow-tooltip prop="scoringState">
                <template slot-scope="scope">
                  {{ $setDictionary("EXAMINATION_SCORING_STATE", scope.row.scoringState) }}
                </template>
              </el-table-column>
              <el-table-column label="是否作弊" align="center" show-overflow-tooltip prop="cheatingState">
                <template slot-scope="scope">
                  {{ $setDictionary("EXAM_CHEATING_STATE", scope.row.cheatingState) }}
                </template>
              </el-table-column>
              <el-table-column label="主观题分数" align="center" show-overflow-tooltip prop="subjectiveScore">
                <template slot-scope="scope">{{ scope.row.subjectiveScore >= 0 ? scope.row.subjectiveScore : '--'
                  }}</template>
              </el-table-column>
              <el-table-column label="客观题分数" align="center" show-overflow-tooltip prop="objectiveScore">
                <template slot-scope="scope">{{ scope.row.objectiveScore >= 0 ? scope.row.objectiveScore : '--'
                  }}</template>
              </el-table-column>
              <el-table-column label="总分" align="center" show-overflow-tooltip prop="totalScore">
                <template slot-scope="scope">{{ scope.row.scoringState == '20' ? scope.row.totalScore : '--'
                  }}</template>
              </el-table-column>
              <el-table-column label="操作" align="center" show-overflow-tooltip>
                <div slot-scope="scope" class="flexcc">
                  <el-button type="text" style="padding:0px 5px"
                    :disabled="scope.row.scoringState != '20' || scope.row.publishResult" size="mini"
                    @click="goScore(scope.row.examinationPerformanceId)">复核</el-button>
                  <el-button type="text" style="padding:0px 5px" v-if="scope.row.hasCheatingRisk" size="mini"
                    @click="checkCheating(scope.row)">异常行为</el-button>
                </div>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>

    <!-- 疑似作弊查看对话框 -->
    <el-dialog title="疑似作弊记录查看" :visible.sync="cheatingDialogVisible" width="800px" top="10%">
      <div v-if="currentCheatingImage" class="cheating-image-container">
        <div v-if="currentCheatingImage.imgUrl" class="image-wrapper">
          <img :src="currentCheatingImage.imgUrl" alt="作弊照片" class="cheating-image" />
        </div>
        <div class="image-info">
          <p><strong>事件时间：</strong>{{ currentCheatingImage.createTime }}</p>
          <p><strong>事件类型：</strong>{{ currentCheatingImage.typeName }}</p>
          <p><strong>备注：</strong>{{ currentCheatingImage.remark }}</p>
        </div>
        <div class="page-navigation">
          <el-button @click="prevImage" :disabled="currentImageIndex <= 0">上一张</el-button>
          <span>{{ currentImageIndex + 1 }} / {{ cheatingImages.length }}</span>
          <el-button @click="nextImage" :disabled="currentImageIndex >= cheatingImages.length - 1">下一张</el-button>
        </div>
      </div>
      <div v-else class="empty-cheating">
        暂无作弊记录
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cheatingDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="confirmCheating">确认作弊</el-button>
        <el-button @click="denyCheating">未作弊</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
export default {
  name: "examination_examineStudent",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  doNotInit: true,
  data() {
    return {
      examinationId: '',
      searchForm: {
        userName: '',
        mobile: '',
        scoringState: '',
      },
      scoringStateList: [],
      // 疑似作弊相关数据
      cheatingDialogVisible: false,
      currentStudent: null,
      cheatingImages: [],
      currentImageIndex: 0,
    };
  },
  created() {
    this.examinationId = this.$route.query.examinationId
    this.getDictionary()
    this.getData()
  },
  mounted() {
  },
  computed: {
    // 当前显示的作弊图片
    currentCheatingImage() {
      return this.cheatingImages[this.currentImageIndex];
    }
  },
  methods: {
    //码值获取
    getDictionary() {
      const scoringStateList = this.$setDictionary(
        "EXAMINATION_SCORING_STATE",
        "list"
      );
      const list1 = [];
      for (const key in scoringStateList) {
        list1.push({
          value: key,
          label: scoringStateList[key],
        });
      }
      this.scoringStateList = list1;
    },
    getData(pageNum = 1) {
      const { userName, mobile, scoringState } = this.searchForm
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        examinationId: this.examinationId,
        userName: userName || undefined,
        mobile: mobile || undefined,
        scoringState: scoringState || undefined,
      };
      this.doFetch({
        url: "/biz/examination/scoring/recheckUserList",
        params,
        pageNum
      }, true, 6);
    },
    goScore(examinationPerformanceId) {
      this.$router.push({
        path: "/web/examination/reviewPaperDetail",
        query: {
          examinationId: this.examinationId,
          examinationPerformanceId,
          ...this.searchForm,
          markType: '02'
        }
      });
    },

    /**
     * 查看疑似作弊记录
     * @param {Object} student - 学生信息
     */
    checkCheating(student) {
      this.currentStudent = student;
      this.cheatingDialogVisible = true;
      this.getCheatingImages(student.examinationPerformanceId);
    },

    /**
     * 获取作弊图片列表
     * @param {String} userId - 用户ID
     */
    getCheatingImages(examinationPerformanceId) {
      // 构造查询参数，这里使用userId作为查询条件
      const json = {
        examinationPerformanceId: examinationPerformanceId,
      };

      this.$post("/biz/examination/scoring/cheatingRecord", json, 3000, true, 6)
        .then((res) => {
          // 筛选出有作弊嫌疑的图片
          this.cheatingImages = res.data;
          this.currentImageIndex = 0;
        })
        .catch((err) => {
          console.error('获取作弊图片失败:', err);
          this.$message.error('获取作弊图片失败');
          this.cheatingImages = [];
        });
    },

    /**
     * 切换到上一张图片
     */
    prevImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }
    },

    /**
     * 切换到下一张图片
     */
    nextImage() {
      if (this.currentImageIndex < this.cheatingImages.length - 1) {
        this.currentImageIndex++;
      }
    },

    /**
     * 确认作弊
     */
    confirmCheating() {
      this.recordCheatingResult('1');
    },

    /**
     * 否认作弊
     */
    denyCheating() {
      this.recordCheatingResult('0');
    },

    /**
     * 记录作弊处理结果
     * @param {String} result - 处理结果 1|0
     */
    recordCheatingResult(result) {
      // 这里需要调用后端API记录处理结果
      // 由于没有提供具体的API，这里使用模拟数据
      const params = {
        examinationPerformanceId: this.currentStudent.examinationPerformanceId,
        eventId: this.currentCheatingImage.id,
        cheatingState: result,
      };

      this.$post("/biz/examination/scoring/updateCheckingState", params, 3000, true, 6)
        .then((res) => {
          if (res.status == '0') {
            const message = result === '1' ? '已确认作弊' : '已确认未作弊';
            this.$message.success(message);
            
            // 显示成功消息
            // 关闭对话框
            this.cheatingDialogVisible = false;
            this.getData()
          }
        })
        .catch((err) => {
          return;
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.meta.level == 1) {
      if (this.$vnode.parent) {
        if (to.name != 'login') {
          this.$vnode.parent.componentInstance.cache = {};
          this.$vnode.parent.componentInstance.keys = [];
        }
      }
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (from.path == '/web/examination/reviewPaperDetail') {
        vm.getData()
      }
    })
  },
};
</script>
<style lang="less" scoped>
.searchBox {
  padding: 0 !important;

  .el-icon-arrow-down:before {
    content: '\e6df' !important;
  }
}

/* 作弊图片查看样式 */
.cheating-image-container {
  .image-wrapper {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f5f5;

    .cheating-image {
      max-width: 100%;
      max-height: 400px;
    }
  }

  .image-info {
    margin-bottom: 20px;
    line-height: 1.8;
  }

  .page-navigation {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
  }
}

.empty-cheating {
  text-align: center;
  padding: 60px 0;
  color: #999;
}
</style>
